import React, { Component } from 'react';
import { List, arrayMove } from 'react-movable';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import CreateMultiSegment from '../overlays/CreateMultiSegment';
import { IsThisConnectionPowerBi } from '../utilities/helperFunctions';
import DimensionMemberSelector from './DimensionMemberSelector';

export default class ItemSelector extends Component {
    //#region React Hooks
    constructor(props) {
        super(props)
        this.state = {
            "iterator": 1,
            "chartId": -1,
            "connectionId": -1,
            "allConnectionIds": [],
            "dimensionName": "",
            "area": "",
            "dataSource": "",
            "connectionName": "",
            "originalSelections": [],
            "dimension": {
                "dimensionAlias": "",
                "dimensionSystemName": "",
                "typeOfDimension": 0,
                "prefix": "",
                "suffix": "",
                "items": []
            },
            "selections": [],
            "newMultiSegmentSelections": [],
            "quickPicksTag": {},
            "msDialogOpen": false,
            "globals": []
        }
    }
    componentDidMount() {
        let dimensionName = ""
        let area = ""
        let chartId = -1
        let connectionId = -1
        let allConnectionIds = []
        let originalSelections = []
        let dataSource = ""
        let connectionName = ""
        let quickPicksTag = {}
        let globals = []

        // Read in the props passed in from the parent
        if (this.props.dimensionName !== undefined) { dimensionName = this.props.dimensionName; }
        if (this.props.area !== undefined) { area = this.props.area; }
        if (this.props.chartId !== undefined) { chartId = this.props.chartId; }
        if (this.props.connectionId !== undefined) { connectionId = this.props.connectionId; }
        if (this.props.allConnectionIds !== undefined) { allConnectionIds = this.props.allConnectionIds; }
        if (this.props.originalSelections !== undefined) { originalSelections = this.props.originalSelections; }
        if (this.props.dataSource !== undefined) { dataSource = this.props.dataSource; }
        if (this.props.connectionName !== undefined) { connectionName = this.props.connectionName; }
        if (this.props.quickPicksTag) { quickPicksTag = this.props.quickPicksTag; }
        if (this.props.globals) {
            for (let g = 0; g < this.props.globals.length; g++) {
                if (this.props.globals[g]["dataSource"] === dataSource || this.props.globals[g]["dataSourceAlias"] === dataSource) {
                    globals.push(this.props.globals[g])
                }
            }
        }

        this.setState({ chartId, connectionId, allConnectionIds, dimensionName, area, dataSource, connectionName, originalSelections, quickPicksTag, globals })
        this.sanitizePowerBiSelections(dimensionName, originalSelections, connectionName)
        this.setSelectedItems(dimensionName, originalSelections)
    }
    componentDidUpdate(prevProps) {
        if (prevProps.chartId !== this.props.chartId) {
            let dimensionName = this.props.dimensionName;
            let area = this.props.area;
            let chartId = this.props.chartId;
            let connectionId = this.props.connectionId;
            let allConnectionIds = this.props.allConnectionIds;
            let originalSelections = this.props.originalSelections;
            let dataSource = this.props.dataSource;
            let connectionName = this.props.connectionName;
            let quickPicksTag = this.props.quickPicksTag
            let globals = []

            if (this.props.globals) {
                for (let g = 0; g < this.props.globals.length; g++) {
                    if (this.props.globals[g]["dataSource"] === dataSource  || this.props.globals[g]["dataSourceAlias"] === dataSource) {
                        globals.push(this.props.globals[g])
                    }
                }
            }

            this.setState({ chartId, connectionId, allConnectionIds, dimensionName, area, dataSource, connectionName, originalSelections, quickPicksTag, globals })
            this.sanitizePowerBiSelections(dimensionName, originalSelections, connectionName);
            this.setSelectedItems(dimensionName, originalSelections);
        }
    }
    render() {
        return (<div>
            <Grid container spacing={3}>
                <Grid item xs={8}>
                    <DimensionMemberSelector
                        className="tree-view"
                        multiSelect={true}
                        chartId={this.state.chartId}
                        dimensionAlias={this.state.dimensionName}
                        connectionId={this.state.connectionId}
                        allConnectionIds={this.state.allConnectionIds}
                        dataSource={this.state.dataSource}
                        connectionName={this.state.connectionName}
                        selections={this.state.selections}
                        addedMultiSegmentSelections={this.state.newMultiSegmentSelections}
                        addedNumber={this.state.newMultiSegmentSelections.length}
                        quickPicksTag={this.state.quickPicksTag}
                        globals={this.state.globals}
                        onSelectionChange={(selections) => {
                            let passedDimension = this.state.dimension;
                            passedDimension["items"] = selections;

                            if (this.props.onSelectionChange) this.props.onSelectionChange(passedDimension);
                            this.setState({ selections });
                        }}
                    />
                </Grid>
                <List
                    values={this.state.selections}
                    onChange={({ oldIndex, newIndex }) => {
                        // If user removed the item
                        let items = this.state.selections
                        let passedDimension = this.state.dimension

                        if (newIndex === -1) {
                            items = this.removeSpecificItemFromCollectionByIndex(oldIndex, items)
                        } else {
                            items = arrayMove(items, oldIndex, newIndex)
                        }

                        passedDimension["items"] = items
                        if (this.props.onSelectionChange) this.props.onSelectionChange(passedDimension)
                        this.setState({ "selections": items })
                    }}
                    renderList={({ children, props }) => <Grid item xs={4} className="selections" {...props}>{children}</Grid>}
                    renderItem={({ value, props }) => {
                        if (value) return <div className="member-selection" {...props}>{value.caption}</div>
                    }}
                    removableByMove={true}
                />
            </Grid>
            <div style={{ "marginTop": "15px", "display": (this.state.dimensionName === "Measures" ? "none" : "block") }}>
                {IsThisConnectionPowerBi(this.state.connectionName) ? <div></div> : <Button
                    size="small"
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                        let msDialogOpen = this.state.msDialogOpen
                        msDialogOpen = !msDialogOpen
                        this.setState({ msDialogOpen })
                    }}>
                    Add New Multi Segment
                </Button>}
                {IsThisConnectionPowerBi(this.state.connectionName) ? <div></div> : <CreateMultiSegment
                    open={this.state.msDialogOpen}
                    dimensionName={this.state.dimensionName}
                    connectionId={this.state.connectionId}
                    allConnectionIds={this.state.allConnectionIds}
                    dataSource={this.state.dataSource}
                    connectionName={this.state.connectionName}
                    closeEvent={() => this.setState({ "msDialogOpen": false })}
                    onNewMultiSegmentCreation={(segmentCombination) => {
                        let addedMultiSegments = this.state.newMultiSegmentSelections
                        addedMultiSegments.push(segmentCombination)
                        this.setState({
                            "msDialogOpen": false,
                            "newMultiSegmentSelections": addedMultiSegments
                        })
                    }}>
                </CreateMultiSegment>}
            </div>
        </div>);
    }
    //#endregion

    //#region Load Methods
    setSelectedItems = (dimensionName, originalSelections) => {
        let dimension = {
            "dimensionAlias": "",
            "dimensionSystemName": "",
            "typeOfDimension": 0,
            "prefix": "",
            "suffix": "",
            "items": []
        };
        let selections = []

        originalSelections.forEach(os => {
            if (os.dimensionAlias === dimensionName) {
                dimension["dimensionAlias"] = os["dimensionAlias"];
                dimension["dimensionSystemName"] = os["dimensionSystemName"];
                dimension["typeOfDimension"] = os["typeOfDimension"];
                dimension["prefix"] = os["prefix"];
                dimension["suffix"] = os["suffix"];

                os.items.forEach(item => {
                    if (item["isSelected"] === true) {
                        selections.push(item);
                    }
                });
            }
        });

        this.setState({ dimension, selections });
    };
    sanitizePowerBiSelections = (dimensionName, originalSelections, connectionName) => {
        if (IsThisConnectionPowerBi(connectionName)) {
            originalSelections.forEach(os => {
                if (os.dimensionAlias === dimensionName) {
                    os.items.forEach(item => {
                        if (item["caption"].indexOf("(Quickpicks)")) {
                            item["caption"] = item["caption"].replace("Target Selection", dimensionName);
                        }
                    });
                }
            });
        }
    };
    removeSpecificItemFromCollection = (nodeValue, selections) => {
        let rtnVal = [];

        selections.forEach(s => {
            let isTheSame = true;

            if (nodeValue.parentName && nodeValue.parentName !== s.parentName) isTheSame = false;
            if (nodeValue.parentType && nodeValue.parentType !== s.parentType) isTheSame = false;
            if (nodeValue.segmentAlias && nodeValue.segmentAlias !== s.segmentAlias) isTheSame = false;
            if (nodeValue.segmentSystemName && nodeValue.segmentSystemName !== s.segmentSystemName) isTheSame = false;
            if (nodeValue.selectionObjectName && nodeValue.selectionObjectName !== s.selectionObjectName) isTheSame = false;
            if (nodeValue.caption !== s.caption) isTheSame = false;
            if (nodeValue.dimensionAlias !== s.dimensionAlias) isTheSame = false;
            if (nodeValue.valueAlias !== s.valueAlias) isTheSame = false;
            if (nodeValue.valueSystemName !== s.valueSystemName) isTheSame = false;

            if (!isTheSame) {
                rtnVal.push(s);
            }
        });

        return rtnVal;
    };
    removeSpecificItemFromCollectionByIndex = (nodeValue, selections) => {
        let rtnVal = [];

        selections.forEach((s, i) => {
            if (i !== nodeValue) {
                rtnVal.push(s);
            }
        });

        return rtnVal;
    }
    //#endregion
}